<template>
  <!-- Portfolio Grid-->
  <section class="page-section bg-light" id="portfolio">
    <div class="container" v-if="showsSorted">
      <div class="text-center">
        <h2 class="section-heading text-uppercase" id="pageTitle">Our most recent shows</h2>
        <h3 class="section-subheading text-muted"></h3>
      </div>
      <div v-if="$apollo.loading" class="text-center">
          <strong>loading ...</strong>  
      </div>
      <div class="row">
        <show-teaser v-for="show in showsSorted" :key="show.id" :show="show"></show-teaser>
      </div>
    </div>
  </section>
</template>

<script>
import _ from "lodash";
import gql from "graphql-tag";

import showTeaser from "./showTeaser";

export default {
  name: "latestShows",
  components: {
    "show-teaser": showTeaser
  },
  data: function() {
    return {
      shows: []
    };
  },
  computed: {
    showsSorted: function() {
      let shows = this.shows.data;
      return _.orderBy(shows, "dateTimeBroadcast", "desc");
    }
  },
  apollo: {
    shows: gql`
      {
        shows(
          first: 3
          where: { column: ON_MIXCLOUD, operator: EQ, value: true }
          orderBy: { field: ID, order: DESC }
        ) {
          data {
            id
            title
            djs
            image
            dateTimeBroadcast
            date_on_air
            url_mixcloud
            tracks {
              artist
              track
            }
          }
        }
      }
    `
  }
};
</script>